import { Component, Input } from '@angular/core';

export interface SectionFlowDataCards {
  title: string;
  subtitle: string;
  data: Array<{
    title: string;
    subtitle: string;
  }>;
}

@Component({
  selector: 'fcp-section-flow-data-cards',
  templateUrl: './section-flow-data-cards.component.html',
  styleUrls: ['./section-flow-data-cards.component.scss']
})
export class SectionFlowDataCardsComponent {

  @Input() public flowChartData: any;
}
